import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography
  } from '@mui/material';
  import { Box } from '@mui/system';
  import React, { useState, useEffect } from 'react';
  import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
  import CustomForm from '@sistemas.mundo/custom-form';
  import CustomModal from '@sistemas.mundo/custom-modal';
  import SearchIcon from '@mui/icons-material/Search';
  import helpers from '@sistemas.mundo/helper-functions';
  
  const FilterSection = ({
    screenSize,
    mobileScreenSize,
    expandedFilters,
    handleExpandFilters,
    filterSeccionTitle,
    onSubmitFilterFunction,
    camposFilter,
    filterButtonText,
    tooltipFilterBtn,
    preventSubmitOnFilter,
    showModalFilter = false,
    onCloseModalFilter = null,
    handleDeshacerFilter = null,
    simplePaginate = false,
    orderByFilter = false,
  }) => {
    const [resetForm, setResetForm] = useState(null);
    const [currentCamposFilter, setCurrentCamposFilter] = useState(null);
  
    useEffect(() => {
      setCurrentCamposFilter(camposFilter);
      if (handleDeshacerFilter) {
        handleDeshacerFilter();
      }
    }, [resetForm]);
  
    if (orderByFilter && !camposFilter[0].elements.some((element) => element.name === 'orderByAsc')) {
      camposFilter[0].elements.push({
        name: "orderByAsc",
        label: "Ordenar de más antiguo",
        placeholder: "Ordenar de más antiguo",
        type: "checkbox",
        descripcion: " ",
        defaultChecked: false,
        grid: {
          xs: 12,
          md: 4,
          lg: 3,
          xl: 3
        }
      });
    }
  
    if (simplePaginate && !camposFilter[0].elements.some((element) => element.name === 'normalPaginate')) {
      camposFilter[0].elements.push({
        name: "normalPaginate",
        label: "Ver totales",
        placeholder: "Ver totales",
        type: "checkbox",
        descripcion: " ",
        defaultChecked: false,
        grid: {
          xs: 12,
          md: 4,
          lg: 3,
          xl: 3
        }
      });
    }
  
    useEffect(() => {
      calcularFiltrosModal(currentCamposFilter ?? camposFilter);
    }, [camposFilter]);
  
    const calcularFiltrosModal = (campos) => {
      let nuevosValores = helpers.object.cloneObjectArray(camposFilter);
      nuevosValores[0].elements.map((element, index) => {
        if (element.value === 'select' && element.multiple) {
          element.value = campos[0].elements[index]?.value ?? [];
        } else {
          element.value = campos[0].elements[index]?.value ?? null;
        }
      });
      setCurrentCamposFilter(nuevosValores);
    };
  
    useEffect(() => { }, [currentCamposFilter]);
  
    const onSubmitForm = (res) => {
      onSubmitFilterFunction(res);
      onCloseModalFilter(true);
    };
  
    const formValuesChanges = (res = null) => {
      let nuevosValores = helpers.object.cloneObjectArray(camposFilter);
      nuevosValores[0].elements.map((element) => {
        return Object.keys(element).map((key) => {
          if (key === 'name' && res && res[element[key]]) {
            element.controled = true;
            element.value = res[element[key]];
          }
        });
      });
      setCurrentCamposFilter(nuevosValores);
    };
  
    const formFiltros = (campos) => {
      return (
        <CustomForm
          formId='formFiltrar'
          onSubmit={onSubmitForm}
          campos={campos}
          submitButtonPosition='right'
          submitButtonText={filterButtonText}
          tooltipSubmitBtn={tooltipFilterBtn}
          iconSubmitBtn={<SearchIcon />}
          resetCamposOnSubmit={false}
          preventSubmitOnEnter={preventSubmitOnFilter}
          getForValues={(res) => formValuesChanges(res)}
          handleBackResetForm={() => setResetForm(Math.random())}
        />
      );
    };
  
    return (
      <Box mb={2}>
        {screenSize[0] > mobileScreenSize && (
          <Accordion expanded={expandedFilters} onChange={handleExpandFilters}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1a-content'
              id='panel1a-header'
            >
              <Typography>{filterSeccionTitle}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box pr={1} pl={1}>
                {formFiltros(camposFilter)}
              </Box>
            </AccordionDetails>
          </Accordion>
        )}
        <CustomModal
          key={resetForm}
          isModalOpened={showModalFilter}
          handleCloseModal={onCloseModalFilter}
          fullWidth={true}
          title={filterSeccionTitle}
          body={formFiltros(currentCamposFilter)}
          showOk={false}
          showCancel={false}
          maxWidth='md'
          id='modalFilter'
        />
      </Box>
    );
  };
  
  export default FilterSection;
  